module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/alert/alert.component.scss
// module id = ./client/app/alert/alert.component.scss
// module chunks = main